var _g, _g2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBrandToshiba = function SvgBrandToshiba(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1000 1000",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bc5ffdc8-a088-46cd-8ff0-8e64ef0f38a8",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M856.9,530.5l12.6-43.4h.2l12.6,43.4ZM897,581.8h37L895.9,456H843.4L805.2,581.8h37l6.7-23.3h41.4Z",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.1,518.9c0-6.9.1-11,.3-14.1.9-19.4,8.6-21.6,23.5-21.6s22.6,2.2,23.6,21.6c.1,3.1.3,7.2.3,14.1s-.2,11-.3,14.1c-1,19.3-8.7,21.6-23.6,21.6s-22.6-2.3-23.5-21.6c-.2-3.1-.3-7.2-.3-14.1m23.8,65.2c38,0,56.3-6.7,58.9-41,.6-8.1.7-16.5.8-24.2s-.2-16.1-.8-24.3c-2.6-34.2-20.9-40.9-58.9-40.9s-56.2,6.7-58.8,40.9c-.7,8.2-.8,16.6-.8,24.3s.1,16.1.8,24.2c2.6,34.3,20.9,41,58.8,41",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.5 456 78.5 487.4 116.1 487.4 116.1 581.8 153.7 581.8 153.7 487.4 191.3 487.4 191.3 456 78.5 456",
    fill: "#183149",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620.1,
    y: 456,
    width: 35.7,
    height: 125.82,
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "512.1 501.9 512.1 456 476.6 456 476.6 581.8 512.1 581.8 512.1 533.3 553.4 533.3 553.4 581.8 588.8 581.8 588.8 456 553.4 456 553.4 501.9 512.1 501.9",
    fill: "#183149",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.9,484.8h24.6c6.5,0,10.5,3,10.5,10.3s-4,10.2-10.5,10.2H722.9Zm0,45.3h24.6c10,0,12.1,4.4,12.1,11.5S755.7,553,747.5,553H722.9ZM773.2,516c15.8-4,20.5-13.5,20.5-27.1,0-27.7-17.4-32.9-42.2-32.9h-64V581.8h67.2c31,0,41.4-13.3,41.4-33.9,0-14.3-3.2-26.9-22.9-31.9",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.2,540.5h33.9c0,6.1.8,10.2,3.8,12.4s6.3,3.4,16.3,3.4,20.2,0,20.2-11.9c0-9.3-5.9-11.4-16.8-12-26.9-1.4-36.7-2.2-46.7-9.7-6.9-5-10.4-14.9-10.4-28.3,0-22.8,7.9-30.8,19.4-36.4s58.2-5.7,70.7,0c15.8,7.3,16.2,22.9,16.2,37.5H416c0-7.4-1.7-9.5-3.1-10.9-3.5-3.1-8.5-3.8-15.7-3.8s-18.8.4-18.8,11c0,8.1,3.5,11.5,12.7,12.1,12.6.8,37.4,1.6,46.3,6.8C449.8,518,453,528,453,544.2c0,23.4-8.4,30.3-20,35.4-13.5,6-58.5,6-73.1-.4-16.3-7.1-16.7-21.4-16.7-38.7",
    fill: "#183149"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ae467b40-d04b-416a-b8a7-0b96691944d0",
    "data-name": "Layer 5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 1000,
    fill: "none"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBrandToshiba, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/brand-toshiba.fda1e3f1.svg";
export { ForwardRef as ReactComponent };